import * as factory from '../../../iawp/src/js/factory'
import openMobileSubmenu from '../../../iawp/src/js/modules/openMobileSubmenu'


new factory.IAInit()
openMobileSubmenu()

document.querySelectorAll('.ia-block-line-infos').forEach(blockLine => {
    blockLine.addEventListener('click', e => {
        blockLine.nextElementSibling.classList.add('visible');
        blockLine.parentElement.classList.add('visible');
        blockLine.parentElement.parentElement.parentElement.style.height = blockLine.nextElementSibling.clientHeight + 'px';
        
        // Add tracking line
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'GAEvent',
            'eventCategory': 'InfosLine',
            'eventAction': 'Click',
            'eventRating': 0,
            'eventLabel': blockLine.id
        });
    })
})
document.querySelectorAll('.ia-block-line-infos__modal__close').forEach(modalBtnClose => {
    modalBtnClose.addEventListener('click', e => {
        modalBtnClose.parentElement.classList.remove('visible');
        modalBtnClose.parentElement.parentElement.classList.remove('visible');
        modalBtnClose.parentElement.parentElement.parentElement.parentElement.removeAttribute('style');
    })
})

document.querySelectorAll('.ia-block-dropdown').forEach((dropdown)=>{
    new factory.IADropdown(
        dropdown.querySelector('.ia-block-dropdown-toggle'), 
        dropdown.querySelector('.ia-block-dropdown-content') 
    )
})

if (!!document.querySelector('#newsletterForm')) {
    document.querySelectorAll('#newsletterForm').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messagesIdClass: '#newsletterForm'
        }).formInside(true)
        form.querySelector('[type="submit"]').addEventListener('click', e => {
            if(form.querySelector('input[name="email"]').value == '' || form.querySelector('input[name="email"]').classList.contains('error')){
                form.querySelector('input[name="email"]').focus()
            }
        })
    })
}
if (!!document.querySelector('.js-ia-blocks-form')) {
    document.querySelectorAll('.js-ia-blocks-form').forEach(form => {
        if(form.classList.contains('is-feedback')){
            let isFormSubmitted = false;
            new factory.IAForm(form, true, {
                rules: {
                    email: {
                        required: true,
                        email: true
                    }
                },
                submitHandler: function () {
                    if (isFormSubmitted == true) {
                        return;
                    } else {
                        isFormSubmitted = true;
                        let ajaxOptions = {
                            url: ajaxurl,
                            type: 'POST',
                            success: function (response) {
                                response = JSON.parse(response);
                                response = response.response.replace(/[\r\n\t]/g, "")

                                if (response == 'ok') {
                                    factory.$(form).find('.contactForm-error').attr('aria-hidden', 'true').addClass('is-hidden');
                                    factory.$(form).find('.contactForm-fields').attr('aria-hidden', 'true').addClass('is-hidden');
                                    factory.$(form).find('.contactForm-confirm').attr('aria-hidden', 'false').removeClass('is-hidden');
        
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'GAEvent',
                                        'eventCategory': 'Formulaires',
                                        'eventAction': 'Submit',
                                        'eventLabel': document.title,
                                        'eventRating': document.querySelector('.star-range').value
                                    });
                                } else {
                                    factory.$(form).find('.contactForm-error').attr('aria-hidden', 'false').removeClass('is-hidden');
                                    isFormSubmitted = false;
                                    if (factory.$(form).find('.g-recaptcha') && typeof (grecaptcha) !== 'undefined') {
                                        grecaptcha.reset(captcha);
                                    }
                                }
                            },
                            error: function (xhr, response, errorThrown) {
                                factory.$(form).find('.contactForm-error').attr('aria-hidden', 'false').removeClass('is-hidden');
                                isFormSubmitted = false;
                                if (factory.$(form).find('.g-recaptcha') && typeof (grecaptcha) !== 'undefined') {
                                    grecaptcha.reset(captcha);
                                }
                            }
                        }
                        ajaxOptions.data = factory.$(form).serialize()
                        factory.$.ajax(ajaxOptions);
                    }
                }
            }).formInside(true)
        }else {
            new factory.IAForm(form, true, {
                rules: {
                    email: {
                        required: true,
                        email: true
                    }
                },
                messagesIdClass: '.contactForm'
            }).formInside(true)
        }
    })
}
if (!!document.querySelector('.captcha-option')) {
    document.querySelectorAll('.captcha-option input').forEach(captchaOption => {
        captchaOption.addEventListener('click', (evt) => {
            let that = evt.currentTarget
            let target = document.getElementById(evt.currentTarget.getAttribute('data-target'))

            if (that.checked) {
                target.value = that.value
            } else {
                target.value = ''
            }
            target.dispatchEvent(new Event('change'))
        })
    })
}

if(!!document.querySelectorAll('.ia-block-latest-post .load-more')){
    document.querySelectorAll('.ia-block-latest-post .load-more').forEach(newsButton => {
        newsButton.addEventListener('click', (e)=>{
            new factory.IALoadMore().addLoader(newsButton)
        })
    })
}
if(!!document.querySelectorAll('.ia-block-list-faq')){
    document.querySelectorAll('.ia-block-list-faq__item').forEach((dropdown)=>{
        new factory.IADropdown(
            dropdown.querySelector('.ia-block-list-faq__item__dropdown'), 
            dropdown.querySelector('.dropdown-content') 
        )
    })
}


// Show menu on scroll to top


var prevScrollpos = window.scrollY;
var heighPreheader = document.querySelector('.section-header').offsetHeight;
let menuAnimate = false;

window.onscroll = function() {
    heighPreheader = document.querySelector('.section-header').offsetHeight
    var currentScrollPos = window.scrollY;
    if (prevScrollpos > currentScrollPos) {
        document.querySelector(".section-header").style.top = "0px";
        if(document.scrollingElement.scrollTop > (document.querySelector('.section-header').offsetHeight - document.querySelector('.grid-header').offsetHeight)){
            if(!document.querySelector('.section-header').classList.contains('has-banner')){
                document.querySelector('.section-header').classList.add('has-banner')
            }
        }else{
            if(document.querySelector('.section-header').classList.contains('has-banner')){
                document.querySelector('.section-header').classList.remove('has-banner')
            }
        }
    } else {
        document.querySelector(".section-header").style.top = - heighPreheader+"px";
        if(!menuAnimate) {
            if (document.querySelector('.section-header .ia-block-navigation__content').classList.contains('is-open')) {
                menuAnimate = true
                setTimeout(() => {
                    document.querySelector('.section-header .ia-block-navigation__toggle #nav-btn').dispatchEvent(new Event('click'));
                    menuAnimate = false
                }, 100)
            }
        }
    }
    prevScrollpos = currentScrollPos;
}


var ready = (callback) => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}
ready(() => {
    swiperInit()

    document.querySelectorAll('.ia-block-departure__reload').forEach(reloadBtn => {
        reloadBtn.addEventListener('click', e => {
            reloadBtn.classList.add('active')
            location.reload(); 
        })
    })

    document.querySelectorAll('[href="#current-page-link"]').forEach(changeUrl => {
        changeUrl.setAttribute('href', urlToRedirect);
    })
})


function swiperInit() {
    if (!!document.querySelector('.swiper-container')) {
        document.querySelectorAll('.swiper-container:not(.is-fullwidth').forEach((el) => {
            if(el.classList.contains('ia-block-process__container')){
                const swiperInstance = new factory.IASwiper(el, {
                    // Overriding rules
                    autoplay: false,
                    itemPerSlide: 2,
                    spaceBetween: 32,
                    // Custom rules
                    scrollbar: {
                        el: el.querySelector('.swiper-scrollbar'),
                        draggable: true,
                    },
                    breakpoints : {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 20
                        },
                        580: {
                            slidesPerView: 1.5,
                            spaceBetween: 20
                        },
                        820: {
                            slidesPerView: 2,
                            spaceBetween: 20
                        },
                    } 
                })
            }
        })
    }
}